import AddNewEvent from '../pages/events/AddNewEvent'
import Calendar from '../pages/events/Calendar'
import ProposalsDashboard from '../pages/events/planning/proposals/ProposalsDashboard'
import BasicView from '../pages/events/SingleEvent/BasicView/BasicView'
import SingleEvent from '../pages/events/SingleEvent/SingleEvent'
import EventFeedbackPublic from '../pages/events/feedback/EventFeedbackPublic'

export default [
  { path: '/events/calendar', element: <Calendar />, title: 'Event Calendar' },
  { path: '/events/proposals', element: <ProposalsDashboard />, title: 'Event Proposals' },
  { path: '/events/add-new', element: <AddNewEvent />, title: 'Add new event' },
  { path: '/events/:id', element: <SingleEvent /> },
  { path: '/event-info/:id', element: <BasicView /> },
  // Public client feedback page — also registered in PublicRouter.js; here so
  // a planner with a staff session can open/test the link.
  { path: '/event-feedback/:token', element: <EventFeedbackPublic /> },
]
